export default class ClassData {
  id: number
  name: string
  locale: string
  state: string
  hidden: boolean
  video: { url: string, content_type: string }
  videoUrl: string
  previewImage: string
  estimatedDurationInMin: number = 0
  estimatedMetValue: number = 0
  description: string
  contentTypes: string[]

  constructor (attributes) {
    Object.assign(this, attributes)
    this.setDefaultDisplayImage()
  }

  get videoSrc () {
    return this.video && this.video.url ? this.video.url : this.videoUrl
  }

  setDefaultDisplayImage () {
    if (!this.previewImage) {
      this.previewImage = `/assets/icon/brand/default-workout/${this.id % 30}.jpg`
    }
  }

}
